import React, { useEffect, useState } from 'react';
import api from '../../../../Services/api';
import { Bar } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { FaBuilding, FaUserTie } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import EstablishmentMonthlyAvrg from './establihsmnetMonthlyData';
ChartJS.register(
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale,
    ChartDataLabels
);


const EstablishmentMasterAvrg = () => {
    let data1 = sessionStorage.getItem('user');
    let corporateData = JSON.parse(data1);
    let id = corporateData.id;
 const navigate = useNavigate();
    const currentYear = new Date().getFullYear();
    const [yearlyData, setYearlyData] = useState(null);
    const [loading, setLoading] = useState(true);

    const [clients, setClients] = useState([]);
    const[division,setDivision] = useState([])
    const [selectedClient, setSelectedClient] = useState('');
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedQuarter, setSelectedQuarter] = useState('Yearly'); 
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
     const [selectedDivision, setSelectedDivision] = useState("NoDivision");
    const [ data, setData ] = useState({ NoOfEmployees: 0, NoOfVendors: 0 })

      const [activeDashboard, setActiveDashboard] = useState("establishment");







    useEffect(() => {

        fetchClients(selectedClient);



    }, [selectedClient]);
    useEffect(()=>{
          const getDivision = async () => {
        try{
            const response = await api.Corporate.getDivison(id);
            if(response.status === 200){
            setDivision(response.data.data);
            }
            else {
                setDivision([])
            }
        }catch(error){
            console.error('Error fetching data', error  );
        }
    }

    getDivision()
    },[id])

useEffect(() => {
    const empcount = async () => {
        try{
            const response = await api.Corporate.employeesandVendorCount(id);
            setData({ NoOfEmployees: response.data.NoOfEmployees, NoOfVendors: response.data.NoOfVendors });
        }catch(error){
            console.error('Error fetching data', error  );
        }
    }
   
    empcount();
  
}, [id])

  useEffect(() => {
    const timer = setTimeout(() => {
        getData()
    }, 1000); 
  
    return () => clearTimeout(timer); 
  }, [id,selectedDivision]); 

    
        const getData = async () => {
            try {
                if(selectedDivision === '' || selectedDivision === 'NoDivision') {
                const response = await api.Corporate.establishmentMasterAvrg(id);
                if(response.status === 200){
                setYearlyData(response.data.data);
                setLoading(false)
                }
                else if(response.status === 400){
                     setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message);
                    setYearlyData(null)
                setLoading(false)

                }
                else if(response.status === 404){
                     setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message);
                    setYearlyData(null)
                setLoading(false)

                }
                else if(response.status === 500){
                     setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message);
                    setYearlyData(null)
                setLoading(false)

                }
                }
                else{
                       const response = await api.Corporate.establishmentMasterAvrg(id,selectedDivision);
                if(response.status === 200) {
                       setYearlyData(response.data.data);
                setLoading(false)
                }
                 else if(response.status === 400){
                     setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message);
                    setYearlyData(null)
                setLoading(false)
                 

                }
                else if(response.status === 404){
                     setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message);
                    setYearlyData(null)
                setLoading(false)

                }
                else if(response.status === 500){
                     setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message);
                    setYearlyData(null)
                setLoading(false)

                }
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
     

    const fetchClients = async () => {
        try {
            const response = await api.Corporate.getClientByCorporateId(id);

            if (response.status === 200) {
                setClients(response.data.data || []);
                console.log("list", response.data.data)
            }
            else if (response.status === 404) {
                setErrorSnackbarOpen(true)
                setSnackbarErrorMessage(response.data.message);
                setClients([])
            }
            else if (response.status === 400) {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage(response.data.message)
                setClients([])
            }
            else {
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage("Unable to fetch details, please try again")
                setClients([])
            }
        }
        catch (error) {
            console.error("Error in fetching the data", error)
        }
    }
    useEffect(() => {
        if (clients.length > 0 && !selectedClient) {
            const firstClientId = clients[0].companyId;
            setSelectedClient(firstClientId);
        }
    }, [clients, selectedClient]);

  const handleClickEstablishment =()=>{
  setActiveDashboard('establishment')
   navigate('/establishmentcorporatedashboard')
}
const handleClickVendor =()=>{
  setActiveDashboard('vendor')
  navigate('/corporatedashboard')
}

    // Data for Doughnut Chart

    const overallAccepted = yearlyData ? parseFloat(yearlyData.overallYearlyAcceptedAvg) : 0;
    const overallRejected = yearlyData ? parseFloat(yearlyData.overallYearlyRejectedAvg) : 0;
    const overallUnderReview = yearlyData ? parseFloat(yearlyData.overallyearlyUnderReviewAvg) : 0;
    const total = overallAccepted + overallRejected + overallUnderReview;

    if ( total >= 100 ){
        remainingPercentage = 0;
    }else{
    var remainingPercentage = (100 - (parseFloat(overallAccepted) + parseFloat(overallRejected) + parseFloat(overallUnderReview))).toFixed(2);

    }

    const doughnutData = {
        labels: ['Accepted', 'Rejected', 'UnderReview', 'Not Uploaded'],
        datasets: [
            {
                data: [overallAccepted, overallRejected, overallUnderReview, remainingPercentage],
                backgroundColor: ['#50c878', '#B22222', '#EFCC00', 'lightgray'],  // Green for accepted, red for rejected
                borderWidth: 0,


            },
        ],
    };
    const chunkData = (data, chunkSize) => {
        let result = [];
        for (let i = 0; i < data.length; i += chunkSize) {
            result.push(data.slice(i, i + chunkSize));
        }
        return result;
    };

    // Data for Bar Chart
    let clientLabels = [];
    let combinedData = [];

    if (yearlyData && yearlyData.EstablishmentAverages) {
        for (let i = 0; i < yearlyData.EstablishmentAverages.length; i++) {
            const client = yearlyData.EstablishmentAverages[i];
            const clientName = clients.find(c => c.companyId === client.companyId)?.clientName || '';

            clientLabels.push(clientName.slice(0, 5)); // Vendor names for X-axis
            // Combine the accepted and rejected data into one (you can sum or average them)
            const combinedValue = client.yearlyAcceptedAverage + client.yearlyRejectedAverage;
            combinedData.push(combinedValue);
        }
    }
    const chunkedVendorLabels = chunkData(clientLabels, 12); // Chunk the labels



    const getQuarterOrHalfData = () => {
        if (yearlyData && yearlyData.EstablishmentAverages) {
            return yearlyData.EstablishmentAverages.map(client => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return client.Q1AcceptedAvg;
                    case 'Q2':
                        return client.Q2AcceptedAvg;
                    case 'Q3':
                        return client.Q3AcceptedAvg;
                    case 'Q4':
                        return client.Q4AcceptedAvg;
                 
                    case 'Yearly':
                        return client.yearlyAcceptedAverage;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };


const handleDivisionChange = (event) =>{
const division = event.target.value
setSelectedDivision(division)
}

    const getQuarterOrHalfDataRejected = () => {
        if (yearlyData && yearlyData.EstablishmentAverages) {
            return yearlyData.EstablishmentAverages.map(client => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return client.Q1RejectedAvg;
                    case 'Q2':
                        return client.Q2RejectedAvg;
                    case 'Q3':
                        return client.Q3RejectedAvg;
                    case 'Q4':
                        return client.Q4RejectedAvg;
                
                    case 'Yearly':
                        return client.yearlyRejectedAverage;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };
    const getQuarterOrHalfDataUnderReview = () => {
        if (yearlyData && yearlyData.EstablishmentAverages) {
            return yearlyData.EstablishmentAverages.map(client => {
                switch (selectedQuarter) {
                    case 'Q1':
                        return client.Q1UnderReviewAvg;
                    case 'Q2':
                        return client.Q2UnderReviewAvg;
                    case 'Q3':
                        return client.Q3UnderReviewAvg;
                    case 'Q4':
                        return client.Q4UnderReviewAvg;
                 
                    case 'Yearly':
                        return client.YearlyUnderReviewAvg;
                    default:
                        return 0;
                }
            });
        }
        return [];
    };

    const acceptedQuarterData = getQuarterOrHalfData();
    const rejectedQuarterData = getQuarterOrHalfDataRejected();
    const underReviewQuarterData = getQuarterOrHalfDataUnderReview();

    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                severity="success"
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
                sx={{ marginTop: '2.9%', marginRight: '7%' }}
            >
                <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
            </Snackbar>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                severity="error"
                open={errorSnackbarOpen}
                autoHideDuration={2000}
                sx={{ marginTop: '2.9%', marginRight: '7%' }}
                onClose={() => setErrorSnackbarOpen(false)}
            >
                <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
            </Snackbar>
                               <section
                                className="d-flex justify-content-between align-items-center px-4 py-2"
                                
                              >
                                {/* Left side: Legend */}
                                <div className="d-flex align-items-center" style={{ letterSpacing: "1px" }}>
                                  <div
                                    style={{
                                      backgroundColor: "#50c878",
                                      width: "15px",
                                      height: "15px",
                                      display: "inline-block",
                                      marginRight: "4px",
                                      borderRadius: "50%",
                                    }}
                                  ></div>
                                  <span style={{ fontSize: "14px" }}>Accepted</span>
                              
                                  <div className="vr mx-3"></div>
                              
                                  <div
                                    style={{
                                      backgroundColor: "#B22222",
                                      width: "15px",
                                      height: "15px",
                                      display: "inline-block",
                                      marginRight: "4px",
                                      borderRadius: "50%",
                                    }}
                                  ></div>
                                  <span style={{ fontSize: "14px" }}>Rejected</span>
                              
                                  <div className="vr mx-3"></div>
                              
                                  <div
                                    style={{
                                      backgroundColor: "#EFCC00",
                                      width: "15px",
                                      height: "15px",
                                      display: "inline-block",
                                      marginRight: "4px",
                                      marginLeft: "8px",
                                      borderRadius: "50%",
                                    }}
                                  ></div>
                                  <span style={{ fontSize: "14px" }}>Under review</span>
                              
                                  <div className="vr mx-3"></div>
                              
                                  <div
                                    style={{
                                      backgroundColor: "lightgray",
                                      width: "15px",
                                      height: "15px",
                                      display: "inline-block",
                                      marginRight: "4px",
                                      borderRadius: "50%",
                                    }}
                                  ></div>
                                  <span style={{ fontSize: "14px" }}>Not Uploaded</span>
                                </div>
                              
                                <div className="flex gap-2">
  <button
    title="Establishment Compliance"
    onClick={handleClickEstablishment}
    className={`flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-300 cursor-pointer
      ${activeDashboard === 'establishment' 
        ? 'bg-success text-white opacity-70' 
        : 'bg-success text-white hover:px-5'}`}
    disabled={activeDashboard === 'establishment'}
  >
    <FaBuilding />
    {activeDashboard === 'establishment' && (
      <span>Establishment Compliance</span>
    )}
  </button>

  <button
    title="Vendor Compliance"
    onClick={handleClickVendor}
    className={`flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-300 cursor-pointer
      ${activeDashboard === 'vendor' 
        ? 'bg-danger text-white opacity-70' 
        : 'bg-danger text-white hover:px-5'}`}
    disabled={activeDashboard === 'vendor'}
  >
    <FaUserTie />
    {activeDashboard === 'vendor' && (
      <span>Vendor Compliance</span>
    )}
  </button>
</div>

                              </section>
            <div>
           {loading ? (
  // 🔹 Loader
  <div
    className="d-flex flex-row align-items-center justify-content-center"
    style={{ marginTop: "80px" }}
  >
    <h3>Loading</h3>
    <div
      className="spinner-grow text-danger"
      style={{ width: "1rem", height: "1rem", marginLeft: "10px" }}
      role="status"
    ></div>
    <div
      className="spinner-grow text-danger"
      style={{ width: "1rem", height: "1rem", marginLeft: "10px" }}
      role="status"
    ></div>
    <div
      className="spinner-grow text-danger"
      style={{ width: "1rem", height: "1rem", marginLeft: "10px" }}
      role="status"
    ></div>
  </div>
) : (
  <>
    {/* 🔹 Division Dropdown — Always Visible */}
    {division && division.length > 0 && (
      <select
        className="mx-4 mt-2 p-2 text text-dark"
        id="division"
        value={selectedDivision || ""}
        onChange={handleDivisionChange}
        style={{ border: "1px solid lightgray", borderRadius: "4px" }}
      >
        <option value="" disabled>
          Select Division
        </option>
        <option value="NoDivision">Overall</option>
        {division.map((div, index) => (
          <option key={index} value={div}>
            {div}
          </option>
        ))}
      </select>
    )}

    {/* 🔹 Establishment MasterData Section */}
    <section className="mx-4 mb-4 mt-3 d-flex flex-column">
     

      {/* 🔹 If Data Exists — Show Graphs */}
      {yearlyData &&
      yearlyData.EstablishmentAverages &&
      yearlyData.EstablishmentAverages.length > 0 ? (
         <div>
        <h1 className="text-light bg-dark text-center p-3">
          Establishment MasterData
        </h1>
     
        <div
          className="d-flex flex-row justify-content-evenly"
          style={{ border: "1px solid lightgray" }}
        >
          {/* 🟢 Doughnut Section */}
          <div>
            <div className="d-flex p-3">
              <h6 className="text-dark">Average Yearly Compliance</h6>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
              }}
            >
              <div style={{ height: "220px", width: "220px" }}>
                <Doughnut
                  data={doughnutData}
                  options={{
                    cutout: "30%",
                    responsive: true,
                    plugins: {
                      legend: { display: false },
                      tooltip: {
                        callbacks: {
                          label: function (context) {
                            let percentage;
                            if (context.label === "Accepted") {
                              percentage = overallAccepted;
                              return `Accepted: ${percentage}%`;
                            } else if (context.label === "Rejected") {
                              percentage = overallRejected;
                              return `Rejected: ${percentage}%`;
                            } else if (context.label === "UnderReview") {
                              percentage = overallUnderReview;
                              return `UnderReview: ${percentage}%`;
                            } else if (context.label === "Not Uploaded") {
                              percentage = remainingPercentage;
                              return `Not Uploaded: ${percentage}%`;
                            }
                          },
                        },
                      },
                      datalabels: {
                        display: true,
                        color: "white",
                        align: "center",
                        anchor: "center",
                        font: { size: 13 },
                        formatter: (value) =>
                          value === 0 ? "" : `${value}%`,
                      },
                    },
                  }}
                />
              </div>
            </div>
          </div>

          {/* 🟡 Bar Chart Section */}
          <div
            className="w-50"
            style={{ borderLeft: "1px solid lightgray" }}
          >
            <div className="p-3 text-center">
              <h6 className="text-dark text-center">
                Establishment Wise Yearly Compliance
              </h6>
            </div>

            {chunkedVendorLabels.map((chunk, index) => (
              <Bar
                className="w-100"
                key={index}
                data={{
                  labels: chunk,
                  datasets: [
                    {
                      label: "Accepted",
                      data: acceptedQuarterData,
                      backgroundColor: "#3CB371",
                      borderColor: "#50c878",
                      borderWidth: 0,
                      barThickness: 25,
                      stack: "stack1",
                    },
                    {
                      label: "UnderReview",
                      data: underReviewQuarterData,
                      backgroundColor: "#EFCC00",
                      borderColor: "#EFCC00",
                      borderWidth: 0,
                      barThickness: 25,
                      stack: "stack1",
                    },
                    {
                      label: "Rejected",
                      data: rejectedQuarterData,
                      backgroundColor: "#B22222",
                      borderColor: "#B22222",
                      borderWidth: 0,
                      barThickness: 25,
                      stack: "stack1",
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  scales: {
                    x: {
                      grid: { display: false },
                      ticks: {
                        display: true,
                        color: "gray",
                        font: { size: 10 },
                        maxRotation: 45,
                        minRotation: 30,
                      },
                    },
                    y: {
                      min: 0,
                      grid: { display: false },
                      ticks: {
                        display: false,
                        stepSize: 10,
                        callback: (value) => value + "%",
                      },
                      stacked: true,
                    },
                  },
                  plugins: {
                    legend: { display: false },
                    tooltip: {
                      callbacks: {
                        label: function (tooltipItem) {
                          const client =
                            yearlyData.EstablishmentAverages[
                              tooltipItem.dataIndex
                            ];
                          const fullVendorName =
                            clients.find(
                              (c) => c.companyId === client.companyId
                            )?.clientName || "";
                          const acceptedValue =
                            acceptedQuarterData[tooltipItem.dataIndex];
                          const rejectedValue =
                            rejectedQuarterData[tooltipItem.dataIndex];
                          const underReviewValue =
                            underReviewQuarterData[tooltipItem.dataIndex];
                          if (tooltipItem.datasetIndex === 0) {
                            return `${fullVendorName}: Accepted ${acceptedValue}%`;
                          } else if (tooltipItem.datasetIndex === 1) {
                            return `${fullVendorName}: UnderReview ${underReviewValue}%`;
                          } else {
                            return `${fullVendorName}: Rejected ${rejectedValue}%`;
                          }
                        },
                      },
                    },
                    datalabels: {
                      display: true,
                      color: "white",
                      align: "center",
                      font: { size: 10 },
                      rotation: -50,
                      formatter: function (value, context) {
                        let roundedValue;
                        if (context.datasetIndex === 0) {
                          roundedValue =
                            acceptedQuarterData[context.dataIndex];
                          return roundedValue ? `${roundedValue}%` : "";
                        } else if (context.datasetIndex === 2) {
                          roundedValue =
                            rejectedQuarterData[context.dataIndex];
                          return roundedValue ? `${roundedValue}%` : "";
                        } else if (context.datasetIndex === 1) {
                          roundedValue =
                            underReviewQuarterData[context.dataIndex];
                          return roundedValue ? `${roundedValue}%` : "";
                        }
                        return "";
                      },
                    },
                  },
                }}
              />
            ))}
          </div>
        </div>
         </div>
      ) : (
        // 🔹 No Data Message
        <div className="text-center p-5">
          <h6 className="text-danger">
            No data found for the selected division
          </h6>
        </div>
      )}
    </section>
  </>
)}
{yearlyData &&
      yearlyData.EstablishmentAverages &&
      yearlyData.EstablishmentAverages.length > 0 && (
        <>
<EstablishmentMonthlyAvrg divisionFilter={selectedDivision}/>
</>
      )}
            </div>
        </>
    );
};

export default EstablishmentMasterAvrg
